import { render } from "./SettingsMenu.vue?vue&type=template&id=5a08b2e7&scoped=true&ts=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts"

import "./SettingsMenu.vue?vue&type=style&index=0&id=5a08b2e7&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a08b2e7"]])

export default __exports__